// src/components/ArtworkCard.jsx
import { Link } from "react-router-dom";
import ShareButton from "./ShareButton";

export default function ArtworkCard({ art }) {
  const imageUrl = art.imageUrl || "https://placehold.co/400x300?text=%D7%90%D7%99%D7%9F+%D7%AA%D7%9E%D7%95%D7%A0%D7%94";
  
  return (
    <article className="card h-100">
      <Link to={`/art/${art.slug || art.id}`} aria-label={`הצג יצירה: ${art.title}`}>
        <img 
          src={imageUrl} 
          alt={art.title} 
          className="card-img-top" 
          loading="lazy"
          onError={(e) => {
            e.target.src = "https://placehold.co/400x300?text=%D7%A9%D7%92%D7%99%D7%90%D7%94+%D7%91%D7%AA%D7%9E%D7%95%D7%A0%D7%94";
          }}
        />
      </Link>
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <h6 className="card-title mb-0">{art.title}</h6>
          <ShareButton 
            url={`/art/${art.slug || art.id}`}
            title={art.title}
            description={art.description}
          />
        </div>
        <Link to={`/u/${art.authorUsername}`} className="text-muted small" aria-label={`פרופיל של ${art.authorUsername}`}>@{art.authorUsername}</Link>
        
        {/* סטטיסטיקות */}
        <div className="text-muted small mt-2">
          <span aria-hidden="true">❤️</span> {art.likesCount || 0} <span aria-hidden="true">·</span> <span aria-hidden="true">👁️</span> {art.viewsCount || 0}
        </div>
      </div>
    </article>
  );
}
